import { TradeBoxSkeleton } from '../../CreateTrade/AssetPageInitiateTradeBox/TradeBoxSkeleton';
import { SetUpSavingsPlanBoxSkeleton } from '../../CreateTrade';

export const TradeSkeletonWithSavings = () => (
  <TradeBoxSkeleton withNav>
    <SetUpSavingsPlanBoxSkeleton />
  </TradeBoxSkeleton>
);
